export const environment = {
  production: false,
  apiUrl: 'https://api.staging.mopphiring.com/api/v1/',
  calendlyClientId: 'O8bj_iGwAhYrGk0X-pdomEOfUOhQKEzrPhGKMXxkBMU',
  calendlyRedirectUri: 'https://staging.mopphiring.com/schedules',
  googleMapsApiKey: 'AIzaSyA8QpDN52RUW1pDr6yXJKJk8Wn9wKQb_BI',
  appName: 'Mopp Hiring - Staging',
  appDomain: 'https://staging.mopphiring.com',
  version: '1.0.3',
  appDefailtLanguage: 'en',
};